var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 34C22 31.7909 23.7909 30 26 30H61.6C63.0772 30 64.4342 30.8142 65.1294 32.1176L70.8706 42.8824C71.5658 44.1858 72.9228 45 74.4 45H127C129.209 45 131 46.7909 131 49V126C131 128.209 129.209 130 127 130H22V34Z",
    fill: "#E7E9EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4126 60.2987C34.7524 58.3901 36.412 57 38.3506 57H141.612C142.857 57 143.8 58.1251 143.581 59.3506L131.587 126.701C131.248 128.61 129.588 130 127.649 130H22L34.4126 60.2987Z",
    fill: "#F4F5F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0239 71.5888C44.6112 70.0311 46.1019 69 47.7667 69H151.108C152.506 69 153.473 70.3976 152.98 71.7056L131.976 127.411C131.389 128.969 129.898 130 128.233 130H22L44.0239 71.5888Z",
    fill: "#1E95F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3616 108.561L97.4241 105.034C97.5723 104.768 97.5723 104.449 97.4241 104.196L96.777 103.078L93.3262 108.986H94.6337C94.9303 108.986 95.2134 108.827 95.3616 108.561Z",
    fill: "#E7E9EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5159 108.562L99.0147 107.724C99.163 107.458 99.163 107.139 99.0147 106.886L98.3677 105.781L96.4805 109.001H97.788C98.0711 108.988 98.3542 108.829 98.5159 108.562Z",
    fill: "#E7E9EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7599 108.986L78.309 103.078L77.662 104.196C77.5137 104.462 77.5137 104.781 77.662 105.034L79.7109 108.561C79.8592 108.827 80.1423 108.986 80.4523 108.986H81.7599Z",
    fill: "#E7E9EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7582 105.727L76.1112 106.831C75.9629 107.097 75.9629 107.417 76.1112 107.669L76.6234 108.561C76.7717 108.827 77.0548 108.987 77.3648 108.987H78.6724L76.7582 105.727Z",
    fill: "#E7E9EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1958 108.984H91.4789C91.7889 108.984 92.072 108.825 92.2203 108.559L95.8599 102.331C96.0081 102.065 96.0081 101.746 95.8599 101.493L95.2128 100.375L90.6836 108.106L91.1958 108.984Z",
    fill: "#E7E9EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8995 108.989L80.3838 101.258H79.3593L79.2245 101.511C79.0762 101.777 79.0762 102.096 79.2245 102.349L82.8641 108.563C83.0123 108.829 83.2954 108.989 83.6055 108.989H84.8995Z",
    fill: "#E7E9EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0088 106.965L94.282 99.6592C94.4302 99.3931 94.4302 99.0737 94.282 98.8209L93.6349 97.7031L89.1191 105.434L90.0088 106.965Z",
    fill: "#E7E9EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7324 101.258L86.0056 108.563C86.1538 108.829 86.4369 108.989 86.7469 108.989H88.0545L83.5252 101.258H81.7324Z",
    fill: "#E7E9EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6794 101.258H84.873L89.1462 108.563C89.2945 108.829 89.5775 108.989 89.8876 108.989H91.1951L86.6794 101.258Z",
    fill: "#E7E9EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6049 91.6602H85.48C85.17 91.6602 84.9004 91.8198 84.7386 92.086L84.0781 93.1904H90.9933L90.3463 92.0727C90.1845 91.8198 89.9014 91.6602 89.6049 91.6602Z",
    fill: "#E7E9EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0535 89H87.0291C86.719 89 86.4494 89.1597 86.2877 89.4258L85.6406 90.5436H89.442L88.7949 89.4258C88.6466 89.1597 88.3636 89 88.0535 89Z",
    fill: "#E7E9EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0573 95.013L91.909 94.7735C91.7607 94.5073 91.4776 94.3477 91.1676 94.3477H83.8884C83.5784 94.3477 83.3088 94.5073 83.147 94.7735L82.5 95.8912H91.545L92.0573 95.013Z",
    fill: "#E7E9EC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8722 97.0391H82.3259C82.0159 97.0391 81.7463 97.1987 81.5845 97.4649L80.9375 98.5826H89.9825L90.8722 97.0391Z",
    fill: "#E7E9EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0199 100.137L79.3594 101.255H88.4044L89.3076 99.7109H80.7613C80.4512 99.7242 80.1682 99.8839 80.0199 100.137Z",
    fill: "#E7E9EC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0568 95.0156L87.541 102.747L88.4442 104.29L92.7173 96.985C92.8656 96.7189 92.8656 96.3995 92.7173 96.1467L92.0568 95.0156Z",
    fill: "#E7E9EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.125,
    height: 20,
    fill: "white",
    transform: "translate(76 89)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7c3698b0.svg";
export { ForwardRef as ReactComponent };